/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Client_Contact_Position_LabelInputs */

const en_client_contact_position_label = /** @type {(inputs: Client_Contact_Position_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.position === "owner") return /** @type {LocalizedString} */ (`Owner`);
	if (i?.position === "vp") return /** @type {LocalizedString} */ (`VP`);
	if (i?.position === "director") return /** @type {LocalizedString} */ (`Director`);
	if (i?.position === "manager") return /** @type {LocalizedString} */ (`Manager`);
	if (i?.position === "analyst") return /** @type {LocalizedString} */ (`Analyst`);
	if (i?.position === "administrative") return /** @type {LocalizedString} */ (`Administrative`);
	if (i?.position === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.position}`)
	
};

const pt_br2_client_contact_position_label = /** @type {(inputs: Client_Contact_Position_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.position === "owner") return /** @type {LocalizedString} */ (`Proprietário`);
	if (i?.position === "vp") return /** @type {LocalizedString} */ (`Vice-presidente`);
	if (i?.position === "director") return /** @type {LocalizedString} */ (`Diretor`);
	if (i?.position === "manager") return /** @type {LocalizedString} */ (`Gerente`);
	if (i?.position === "analyst") return /** @type {LocalizedString} */ (`Analista`);
	if (i?.position === "administrative") return /** @type {LocalizedString} */ (`Administrativo`);
	if (i?.position === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.position}`)
	
};

/**
* | position | output |
* | --- | --- |
* | "owner" | "Owner" |
* | "vp" | "VP" |
* | "director" | "Director" |
* | "manager" | "Manager" |
* | "analyst" | "Analyst" |
* | "administrative" | "Administrative" |
* | "other" | "Other" |
* | * | "{position}" |
*
* @param {Client_Contact_Position_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_contact_position_label = /** @type {((inputs: Client_Contact_Position_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Contact_Position_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_contact_position_label(inputs)
	return pt_br2_client_contact_position_label(inputs)
});